export const getSubtotalRemainingBeforeAovUnlockProductVariantSelectorUtil = ({
  aovLock,
  subtotal
}) => {
  if (!aovLock) {
    return
  }

  const aovLockFloat = parseFloat(aovLock)
  const diff = aovLockFloat - subtotal
  if (diff < 1 && diff > 0) {
    return diff
  }
  return Math.round(diff)
}
